import React from 'react';
import { Box } from '@mui/material';

// The left-border "rail" used to set a block of related lines off from the
// page — a career entry, a numbered step list — without a full Paper/Card.
const RailBox = ({ sx, children }) => (
    <Box sx={{ borderLeft: '2px solid', borderColor: 'divider', pl: 2, ...sx }}>
        {children}
    </Box>
);

export default RailBox;
